import {
    InputProps,
    InputVariantsProps
} from "@omni/ui/components/Form/Input/input.props";
import { input } from "@omni/ui/components/Form/Input/input.style";
import { attempt } from "@omni/utils/function.utils";
import { ChangeEvent, useRef } from "react";

import { mergeRefs } from "@/utils/react.utils";

const Input = ({
    valid,
    invalid,
    type = "text",
    className,
    ref,
    inputSize = "md",
    onAutofill,
    onChange,
    ...attributes
}: InputProps) => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const combinedRef = mergeRefs(inputRef, ref);

    const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange?.(event);

        const input = inputRef.current;
        if (!input) return;

        const autofilled = attempt(() => input.matches(":autofill"), false);

        if (autofilled) {
            onAutofill?.(event);
        }
    };

    let variant = "";

    const baseVariantProps: InputVariantsProps = {
        inputSize,
        invalid,
        valid
    };

    switch (type) {
        case "file":
            variant = input({
                inputType: "file",
                className,
                ...baseVariantProps
            });
            break;
        case "range":
            variant = input({
                inputType: "range",
                className,
                ...baseVariantProps
            });
            break;
        case "radio":
            variant = input({
                inputType: "radio",
                className,
                ...baseVariantProps
            });
            break;
        case "checkbox":
            variant = input({
                inputType: "checkbox",
                className,
                ...baseVariantProps
            });
            break;
        case "date":
            variant = input({
                inputType: "date",
                className,
                ...baseVariantProps
            });
            break;
        default:
            variant = input({
                inputType: "default",
                className,
                ...baseVariantProps
            });
    }

    return (
        <input
            {...attributes}
            aria-invalid={invalid}
            className={variant}
            ref={combinedRef}
            type={type}
            onChange={handleOnChange}
        />
    );
};

export { Input };
